<ion-footer class="footer ion-padding-horizontal ion-align-items-center">
  <ion-button 
  class="round-corners ion-no-padding small-padding"
  [ngClass]="{'active-footer-btn': activeSection.accounts}"
  (click)="navigateToPage(PageURL.ACCOUNTS)" 
  [fill]="activeSection.accounts ? 'solid' : 'clear'"  
  shape="round">
    <img [ngClass]="{'footer-icon-active': activeSection.accounts, 'footer-icon': !activeSection.accounts}"
      class="ion-margin-end" 
      [src]="accountsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.accounts" >{{'bottomNavigation_dashboard'|translate}}</ion-text>
  </ion-button>
  <ion-button class="round-corners ion-no-padding small-padding"
  [ngClass]="{'active-footer-btn': activeSection.payments}"
  (click)="navigateToPage(PageURL.PAYMENTS)" 
  [fill]="activeSection.payments ? 'solid' : 'clear'"  
  shape="round">
    <img [ngClass]="{'footer-icon-active': activeSection.payments, 'footer-icon': !activeSection.payments}"
      class="ion-margin-end" 
      [src]="paymentsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.payments" >{{'bottomNavigation_payments'|translate}}</ion-text>
  </ion-button>
  <ion-button
  *ngIf="cashbackApproved"
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.bicashback}"
  (click)="navigateToPage(PageURL.BICASHBACK)" 
  [fill]="activeSection.bicashback ? 'solid' : 'clear'" 
  shape="round">
    <img [ngClass]="{'footer-icon-active': activeSection.bicashback, 'footer-icon': !activeSection.bicashback}"
      class="ion-margin-end" 
      [src]="cashbackIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}"
      *ngIf="activeSection.bicashback" >{{'bottomNavigation_biCashback'|translate}}</ion-text>
  </ion-button>
  <ion-button 
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.reports}"
  (click)="navigateToPage(PageURL.BI_REPORTS)" 
  [fill]="activeSection.reports ? 'solid' : 'clear'" 
  shape="round">
    <img [ngClass]="{'footer-icon-active': activeSection.reports, 'footer-icon': !activeSection.reports}"
      class="ion-margin-end" 
      [src]="reportsIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}"
      *ngIf="activeSection.reports" >{{'reports_reports'|translate}}</ion-text>
  </ion-button>
  <ion-button 
  class="round-corners ion-no-padding small-padding" 
  [ngClass]="{'active-footer-btn': activeSection.more}"
  (click)="navigateToPage(PageURL.VIEW_MORE)"
  [fill]="activeSection.more ? 'solid' : 'clear'"
  shape="round">
  <img [ngClass]="{'footer-icon-active': activeSection.more, 'footer-icon': !activeSection.more}"
  class="ion-margin-end" 
  [src]="viewMoreIcon"/>
    <ion-text [ngClass]="{'footer-text': selectedTheme == 'light', 'footer-text-dark': selectedTheme == 'dark'}" 
      *ngIf="activeSection.more" >{{'bottomNavigation_more'|translate}}</ion-text>
  </ion-button>
</ion-footer>